import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import {loginAdminUser} from '../../../api/authApi'
import { useNotification } from '../../../hooks/useNotification.js';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../reducer/authSlice.js';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showErrorNotification, showSuccessNotification } = useNotification();

  const validateEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleLogin = async () => {
    let formErrors = { email: '', password: '' };
    let isValid = true;

    if (!email.trim()) {
      formErrors.email = 'Email is required';
      isValid = false;
    } else if (!validateEmail(email)) {
      formErrors.email = 'Enter a valid email address';
      isValid = false;
    }

    if (!password.trim()) {
      formErrors.password = 'Password is required';
      isValid = false;
    }

    setErrors(formErrors);

    if (isValid) {
      // Call API or proceed with login
      try {
        const res = await loginAdminUser(email, password, rememberMe);
        if (res?.success) {
          dispatch(login({ token: res.data?.token,user:res?.details }));
          navigate('/');
          showSuccessNotification('Login success');
        } else {
          showErrorNotification('Login failed, please check your credentials');
        }
      } catch (error) {
        showErrorNotification('Login failed, please check your credentials');
        console.error('Login failed:', error);
      }
    }
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%' }}>
        <Box textAlign="center" mb={3}>
          <img src="/assets/images/logo/logo.svg" alt="Logo" style={{ height: 60 }} />
        </Box>

        <Typography variant="h5" fontWeight="bold" mb={1} align="center">
          Welcome Back!
        </Typography>
        <Typography variant="body2" mb={3} align="center" color="text.secondary">
          Please enter your credentials to log in.
        </Typography>

        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />

        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={Boolean(errors.password)}
          helperText={errors.password}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          }
          label="Remember me"
          sx={{ mt: 1 }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, background: '#1075FF', }}
          onClick={handleLogin}
        >
          Log In
        </Button>
      </Paper>
    </Box>
  );
};

export default LoginScreen;
